<script lang="ts">
import { defineComponent, PropType, ref } from 'vue'
import TabDefault from '@/components/tab/TabDefault.vue'
import { solutionPath } from '@/generated/railsRoutes'

export default defineComponent({
  name: 'ContentsTab',

  components: {
    TabDefault,
  },

  props: {
    /**
     * solution の id
     */
    id: {
      type: [Number, String],
      required: true,
      validator: (value: number | string) => {
        return typeof value === 'number'
          ? !!(value >= 1)
          : typeof value === 'string'
            ? !!value
            : false
      },
    },

    /**
     * 現在ページのタブ item key
     * @param 基本情報: index
     * @param 資料: documents
     * @param 動画: videos
     */
    currentTabKey: {
      type: String as PropType<'index' | 'documents' | 'videos'>,
      default: '',
    },

    tabOption: {
      type: Object as PropType<{
        hasDocuments: boolean,
        hasVideos: boolean,
      }>,
      required: true,
    },
  },

  setup(props) {
    const items = ref([
      {
        key: 'index',
        label: '基本情報',
        to: solutionPath({ id: props.id }),
        isShow: true,
      },

      {
        key: 'documents',
        label: 'お役立ち資料',
        to: `${solutionPath({ id: props.id })}/documents`,
        isShow: props.tabOption.hasDocuments,
      },

      {
        key: 'videos',
        label: 'ノウハウ動画',
        to: `${solutionPath({ id: props.id })}/videos`,
        isShow: props.tabOption.hasVideos,
      },
    ])

    return {
      // data
      items,
    }
  }
})
</script>

<template>
  <TabDefault
    :items="items"
    :current-tab-key="currentTabKey" />
</template>
